import React from 'react';
import { withTranslation } from 'react-i18next';

import BodyPortal from '../portals/body-portal';

import OverlayUIElement from './overlay-ui-element';

class RoleSelector extends OverlayUIElement {
    static defaultProps = {
        optionsClassName: ''
    }

    constructor(props) {
        super(props);

        this.initialValue = props.value;
        this.popoutElement = null;

        this.state = {
            visible: false,
            value: props.value
        };

        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    handleValueClick = () => {
        if (this.props.disabled) {
            return;
        }

        this.show();
    }

    handleConfirmationClick = () => {
        this.props.onChange && this.props.onChange(this.state.value);

        this.hide();
    }

    handleConfirmationCancel = () => {
        this.setState({
            value: this.initialValue
        });

        this.hide();
    }

    handleDocumentClick(event) {
        if (event.target === this.popoutElement || event.target.closest('.role-selector-options')) {
            return;
        }

        this.hide();
    }

    handleKeyDown(event) {
        if (!this.state.visible) {
            return;
        }

        switch (event.which) {
            case 27: // Esc
                this.hide();
                break;

            default:
                return null;
        }
    }

    handleItemClick(selectedItem) {
        if (selectedItem.id === this.state.value) {
            return;
        }

        this.setState({
            value: selectedItem.id
        });

        if (!this.props.withConfirmation) {
            this.hide();

            this.props.onChange && this.props.onChange(selectedItem.id);
        }
    }

    show() {
        if (this.state.visible || this.props.disabled) {
            return;
        }

        this.setState({
            visible: true
        });

        this.handleOverlayElementShow();

        this.props.onShow && this.props.onShow()

        setTimeout(() => {
            document.addEventListener('click', this.handleDocumentClick);
        }, 0);

        window.addEventListener('keydown', this.handleKeyDown);
    }

    hide() {
        if (!this.state.visible) {
            return;
        }

        document.removeEventListener('click', this.handleDocumentClick);

        this.setState({
            visible: false
        });

        this.props.onHide && this.props.onHide()

        window.removeEventListener('keydown', this.handleKeyDown);
        this.handleOverlayElementHide();
    }

    get selectedItem() {
        return this.props.roles.find(role => role.id === this.state.value);
    }

    get confirmationText() {
        const { confirmationText, t } = this.props;
        return confirmationText ?? t('common:Update');
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value
        });
    }

    componentDidMount() {
        this.setOverlayElement(this.popoutElement, this.overlayPlaceholder ? this.overlayPlaceholder.parentNode : null);

        const ctrl = {
            show: () => {
                this.show();
            },
            hide: () => {
                this.hide();
            }
        };

        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = ctrl;
            } else {
                this.props.provideController && this.props.provideController(ctrl);
            }
        }
    }

    componentWillUnmount() {
        this.hide();
        this.handleOverlayParentDestroy();

        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = null;
            } else {
                this.props.provideController && this.props.provideController(null);
            }
        }
    }

    render() {
        const { t } = this.props;

        return (
            <div className={'role-selector' + (this.state.visible ? ' visible' : '') + (this.props.disabled ? ' disabled' : '')}>
                <div className="role-selector-value" onClick={this.handleValueClick}>
                    { this.props.children }

                    <span className="overlay-placeholder" ref={element => this.overlayPlaceholder = element}>
                        <BodyPortal>
                            <div className={'role-selector-options ' + this.props.optionsClassName + (this.state.visible ? ' visible' : '')} ref={element => {this.popoutElement = element}}>

                                <div className="role-selector-options-body">

                                    <ul className="role-selector-options-list">
                                        {
                                            this.props.roles.filter(role => !role.disabled).map((role, index) => {
                                                return (
                                                    <li key={index} onClick={this.handleItemClick.bind(this, role)} className={'item' + (role.id === this.state.value ? ' selected' : '')}>
                                                        <span className="check">
                                                            <i className="ion ion-checkmark-round" />
                                                        </span>

                                                        <span className="value">
                                                            { t(`roles.${role.title}`) }

                                                            <small>{ t(`roles.${role.info}`) }</small>
                                                        </span>
                                                    </li>
                                                );
                                            })
                                        }
                                    </ul>
                                </div>

                                { this.props.withConfirmation ? (
                                    <div className="role-selector-options-foot">
                                        <button className="btn btn-small btn-secondary" onClick={this.handleConfirmationCancel}>{ t('common:Cancel') }</button>

                                        <button className="btn btn-small btn-success" onClick={this.handleConfirmationClick}>{this.confirmationText}</button>
                                    </div>
                                ) : null}
                            </div>
                        </BodyPortal>
                    </span>
                </div>
            </div>
        );
    }
}

export default withTranslation(['user', 'common'])(RoleSelector);
